<template>
  <!--  干线订单列表 MainOrdersList-->
  <div class="main-orders-list padding-sm">
    <div class="search-content">
      <el-form
        class
        :model="searchData"
        ref="searchForm"
        label-width="100px"
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item label="主单号">
          <el-input
            v-model="searchData.orderNo"
            class="edit-form__input"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="运单号">
          <el-input
            v-model="searchData.detailOrderNo"
            class="edit-form__input"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="物流产品">
          <el-select v-model="searchData.productId" placeholder="请选择">
            <el-option
              v-for="item in productList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运输方式">
          <el-select v-model="searchData.transportType" placeholder="请选择">
            <el-option
              v-for="item in transportTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="状态">-->
<!--          <el-select v-model="searchData.orderStatus" placeholder="请选择">-->
<!--            <el-option-->
<!--              v-for="item in orderStatusList"-->
<!--              :key="item.value"-->
<!--              :label="item.label"-->
<!--              :value="item.value"-->
<!--            ></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="收货状态">
          <el-select v-model="searchData.receiptConfirmation" placeholder="请选择">
            <el-option
              v-for="(item,index) in receiptConfirmationList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" " label-width="10px">
          <el-button type="primary" icon="el-icon-search" @click="search"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="table-content margin-top">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{ background: 'rgb(242, 246, 252)' }"
        @selection-change="handleSelectionChange"
        tooltip-effect="dark"
      >
        <el-table-column
          align="center"
          type="index"
          label="序号"
          width="55"
          fixed="left"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="orderNo"
          label="主单号"
          width="220px"
        ></el-table-column>
        <!-- 2023年14周周五版本删除列表入仓相关字段 -->
        <!-- <el-table-column
          align="center"
          prop="orderStatus"
          label="状态"
          width="100px"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.orderStatus === 1">未入仓</div>
            <div v-else-if="scope.row.orderStatus === 2">已入仓</div>
            <div v-else-if="scope.row.orderStatus === 3">已出仓</div>
          </template>
        </el-table-column> -->
        <el-table-column
          align="center"
          prop="detailNum"
          label="主单下子单数"
          width="110px"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="lineProductName"
          label="运力商产品名"
          width="150px"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="productName"
          label="货代拼产品名"
          width="150px"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="transferSupplierWarehouse"
          label="发货仓"
          width="150px"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="cityCarrier"
          label="市内配送商"
          width="140px"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="lineSupplierWarehouse"
          label="收货仓"
          width="140px"
        ></el-table-column>
        <el-table-column
          align="center"
          label="收货状态"
          width="120px"
        >
          <template slot-scope="scope">
            {{ scope.row.receiptConfirmation ? "已收货" : "未收货" }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="allCbm"
          label="预报总体积(CBM)"
          width="150px"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="allWeight"
          label="预报总重量(KG)"
          width="150px"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="boxNum"
          label="预报总箱数"
          width="150px"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="amount"
          label="预报费用(CNY)"
          width="150px"
        ></el-table-column>
        <!-- 2023年14周周五版本删除列表入仓相关字段 -->
        <!-- <el-table-column
          align="center"
          prop="confirmAllCbm"
          label="实际体积(CBM)"
          width="150px"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="confirmAllWeight"
          label="实际重量(KG)"
          width="150px"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="confrimBoxNum"
          label="实际箱数"
          width="150px"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="storageTime"
          label="入仓时间"
          width="150px"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="storageOperator"
          label="入仓确认人"
          width="150px"
        ></el-table-column> -->
        <el-table-column
          align="left"
          label="操作"
          width="210px"
          fixed="right"
        >
          <template slot-scope="scope">
            <div>
<!--              <el-button-->
<!--                class="margin-right-sm"-->
<!--                type="primary"-->
<!--                size="mini"-->
<!--                @click="showOutBound(scope.row)"-->
<!--                v-if="scope.row.orderStatus === 2"-->
<!--              >出仓</el-button>-->

<!--              <el-button-->
<!--                type="primary"-->
<!--                size="mini"-->
<!--                @click="enterStorage(scope.row)"-->
<!--                v-if="scope.row.orderStatus === 1"-->
<!--                >入仓</el-button-->
<!--              >-->
              <template v-if="scope.row.orderStatus !== 1">
                <el-button
                  type=""
                  plain
                  size="mini"
                  @click="query(scope.row)"
                  class="tabs-button"
                  >查询</el-button
                >
<!--                <el-button-->
<!--                  type="primary"-->
<!--                  size="mini"-->
<!--                  @click="trajectoryMg(scope.row)"-->
<!--                  >轨迹管理</el-button-->
<!--                >-->
                <br/>
              </template>
              <template v-if="!scope.row.receiptConfirmation">
                <el-button
                  type=""
                  plain
                  size="mini"
                  @click="showPickUpGoods(scope.row)"
                  class="tabs-button"
                >提货信息</el-button>
                <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="clickConfirmGetGoods(scope.row)"
                  class="tabs-button"
                >确认收货</el-button>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="paging-row"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="pageSizes"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="totalListNum">
      </el-pagination>

    </div>
    <el-dialog :visible.sync="dialogVisibleOutBound"
               @closed="hideOutBound"
               title="订单出仓"
               width="400px">
      <el-date-picker placeholder="请选择出仓日期"
                      class="edit-form__input margin-right-sm"
                      v-model="editDataOutBound.eta"
                      align="right"
                      type="date"
                      value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-button @click="submitOutBound"
                 type="primary"
                 style="width: 120px;">确认</el-button>
    </el-dialog>

    <el-dialog :visible.sync="dialogTableVisible">
      <trajectories :mainOrders="mainOrders" :jobId="jobId" @update="update"></trajectories>
    </el-dialog>
    <el-dialog :visible.sync="visiblePickUpGoods"
               @closed="hidePickUpGoods"
               title="提货信息"
               width="400px">
      <el-form label-width="100px" label-position="left" size="small">
        <el-form-item label="提货信息">
          {{ ["","自提","配送"][dataPickUpGoods.pickType] || dataPickUpGoods.pickType || "-" }}
        </el-form-item>
        <el-form-item label="提货仓库">
          {{ dataPickUpGoods.wareHouseName }}
        </el-form-item>
        <el-form-item label="提货联系人">
          {{ dataPickUpGoods.contactPerson }} {{ dataPickUpGoods.tel }}
        </el-form-item>
        <el-form-item label="提货时间">
          {{ dataPickUpGoods.pickTime||"-" }} ~ {{ dataPickUpGoods.pickEndTime||"-" }}
        </el-form-item>
        <el-form-item label="提货地址">
          {{ dataPickUpGoods.address }}
        </el-form-item>
        <div style="text-align: center;">
          <el-button type="primary" plain style="width: 120px;" @click="hidePickUpGoods">确定</el-button>
        </div>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import Trajectories from "./components/Trajectories.vue";
import {isObject} from "my-tools-kit";
import {pagingMixins} from "@/assets/js/pagingMixins";
import dayjs from "dayjs";
import {sendCustomerOperationRecord} from "../../assets/js/baseDataRuquest";

export default {
  mixins:[pagingMixins],
  components: {
    Trajectories,
  },
  data() {
    return {
      searchData: {
        detailOrderNo: "",//运单号
        orderNo: "",//主单号
        orderStatus: "",//订单状态 1:未入仓 2：已入仓 3:已出仓
        productId: "",//物流产品id
        transportType: "",//运输方式
        receiptConfirmation: "",//收货状态
      },
      startDateValue: null,
      productList: [],
      transportTypeList: [],
      receiptConfirmationList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "已收货",
          value: true,
        },
        {
          label: "未收货",
          value: false,
        },
      ],
      orderStatusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未入仓",
          value: 1,
        },
        {
          label: "已入仓",
          value: 2,
        },
        {
          label: "已出仓",
          value: 3,
        },
      ],
      selectionOptions: [],

      dialogTableVisible: false,
      mainOrders: [],
      mainOrder: {},
      jobId: "",
      /* 出仓 */
      dialogVisibleOutBound:false,
      editDataOutBound:{
        eta:"",
        orderId:'',
      },
      // 查看提货信息
      loadingPickUpGoods:false,
      visiblePickUpGoods:false,
      dataPickUpGoods:{},
    };
  },
  computed: {},
  created() {
    this.getList();
    this.getTransportTypeList();
    this.getProductList();
  },
  methods: {
    /**
     * 获取 列表
     */
    getList() {
      let url = "/carrier/order/mainOrderPageList";
      let data = this.jointSearchData();
      this.loading = true;
      return this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.loading = false;
          this.tableData = res.data.list||[];
          this.totalListNum = res.data.total||[];
          return res;
        })
        .catch((res) => {
          this.loading = false;
          this.tableData = [];
          this.totalListNum = 10;
        });
    },
    getProductList() {
      //物流产品
      this.axios
        .get("/carrier/baseData/getLogisticsProductList")
        .then((res) => {
          let result = res.data.datas;
          if (result && result.length > 0) {
            result.map((item) => {
              item.label = item.name;
              item.value = item.value;
            });
          }
          result.unshift({label:'全部',value:''});
          this.productList = result;
        });
    },
    getTransportTypeList() {
      //运输方式
      this.axios.get("/fbxData/getAllTransportTypes").then((res) => {
        let result = res.data.datas;
        if (result && result.length > 0) {
          result.map((item) => {
            item.label = item.name;
            item.value = item.value;
          });
        }
        result.unshift({label:'全部',value:''});
        this.transportTypeList = result;
      });
    },

    handleSelectionChange(val) {
      this.selectionOptions = val;
    },
    enterStorage(item) {
      // 入仓
      this.$router.push({
        path: "/index/PersonalCenter/Personalindex/mainOrders/mainOrdersDetail",
        query: { enterType: "edit", orderId: item.orderId },
      });
    },
    query(item) {
      // 查询
      this.$router.push({
        path: "/index/PersonalCenter/Personalindex/mainOrders/mainOrdersDetail",
        query: { enterType: "readonly", orderId: item.orderId },
      });
    },

    trajectoryMg(val) {
      this.dialogTableVisible = true;
      this.mainOrder = val;
      console.log("this.mainOrder", this.mainOrder);
      this.jobId = val.jobId;
      this.getJobsTracksInfoList(val.jobId);
    },
    getJobsTracksInfoList(val) {
      this.axios.post(`/carrier/track/getJobsTracksInfo/${val}`).then((res) => {
        console.log("res.datas", res);

        this.mainOrders = res.data.datas;
      });
    },
    update(){
      this.getJobsTracksInfoList(this.jobId);
    },
    /**
     * 确认出库
     */
    showOutBound(row={}){
      this.dialogVisibleOutBound = true;
      this.editDataOutBound.orderId = row.orderId;
    },
    hideOutBound(){
      this.dialogVisibleOutBound = false;
      this.editDataOutBound = {
        eta:"",
        orderId:"",
      };
    },
    submitOutBound(){
      let data = this.editDataOutBound;
      if(!data.eta) return this.$message.error('出仓日期不能为空');
      if(!data.orderId) return this.$message.error('出仓订单ID异常');
      this.axios.post(`/carrier/order/confirmOutBound`,this.qs.stringify(data)).then((res) => {
        if (res.data.code !== 200) {
          return this.$message.info(res.data.message || "服务器繁忙");
        }
        this.$message.success("出仓成功");
        this.hideOutBound();
        this.getList();
      });
    },
    /**
     * 显示/隐藏 提货信息
     */
    showPickUpGoods(row){
      this.getPickUpGoods(row)
        .then(res=>{
          let obj = Object.assign({},res.data);
          obj.pickTime = obj.pickTime ? dayjs(obj.pickTime).format('YYYY-MM-DD') : ''
          obj.pickEndTime = obj.pickEndTime ? dayjs(obj.pickEndTime).format('YYYY-MM-DD') : ''
          this.dataPickUpGoods = obj;
          this.visiblePickUpGoods = true;
        })
    },
    hidePickUpGoods(){
      this.visiblePickUpGoods = false;
      this.dataPickUpGoods = {};
    },
    /**
     * 获取提货信息
     * @param row
     * @returns {Promise<AxiosResponse<any>>}
     */
    getPickUpGoods(row){
      let url = "/carrier/order/pickupGoods";
      let data = row||{};
      // this.loadingPickUpGoods = true;
      return this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
    },
    /**
     * 确认收货
     */
    clickConfirmGetGoods(row){
      this.$confirm("是否确认收货？","确认收货")
        .then(res=>{
          sendCustomerOperationRecord('收货确认', `主单号：${row.orderNo}`)
          this.confirmGetGoods(row.orderId)
          this.getList();
        })
        .catch(() => {});
    },
    confirmGetGoods(mainId=""){
      let url = `/api/carrier/order/receiptConfirmation/${mainId}`;
      return this.axios.get(url)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .catch(res=>{
          this.$message({
            type: 'error',
            message: `确认收货：${res.message || "网络异常，请稍后再试"}`
          });
        })
    },
  },
};
</script>

<style scoped  lang="scss">
.tabs {
  margin-top: 20px;
}
.tabs-button{
  margin: 3px 10px 3px 0;
  & + & {
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mainOrders/main-orders-list.vue